import Enum from '@/modules/core/app/helpers/Enum';

export class FinancialAdvisorProRoute extends Enum {
  name!: string;
  path!: string;

  static DASHBOARD: FinancialAdvisorProRoute = {
    name: 'financial-advisor-dashboard',
    path: 'overview'
  };

  static OPPORTUNITIES: FinancialAdvisorProRoute = {
    name: 'financial-advisor-opportunities',
    path: 'opportunities'
  };
}
